import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';

/**
 * Sandbox page — al cargar envía un evento a Sentry automáticamente.
 * Útil para verificar conectividad sin interacción manual.
 * Navega a /sandbox/sentry-ping para dispararlo.
 */
export default function SentryPing() {
  const [eventId, setEventId] = useState<string | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = Sentry.captureMessage('[S5-FE-01] Sentry ping via URL — /sandbox/sentry-ping', 'info');
    setEventId(id || null);
    setReady(true);
  }, []);

  if (!ready) { return null; }

  return (
    <div style={{ padding: '2rem', fontFamily: 'monospace' }}>
      {eventId ? (
        <>
          <p>✅ Evento enviado a Sentry</p>
          <p>Event ID: <strong>{eventId}</strong></p>
          <p style={{ marginTop: '1rem', color: '#666' }}>
            Busca <code>[S5-FE-01] Sentry ping via URL</code> en tu dashboard de Sentry.
          </p>
        </>
      ) : (
        <p>⚠️ Sentry no está inicializado — revisa que VITE_SENTRY_DSN esté configurado.</p>
      )}
    </div>
  );
}
